import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import ValidatorContext from "formvalidation/FormContext";
import { useValidators } from "formvalidation/hooks";
import React from "react";
import { AdvancingProvideFieldWithLabel } from "./AdvancingProvideFieldWithLabel";
import { InPageEditingProvider } from "./InPageEditingContext";
import { SectionTemplateHeader } from "./SectionTemplateHeader";
import { SectionTemplateLoadingSkeleton } from "./SectionTemplateLoadingSkeleton";
import { AdvancingFormSection, AdvancingProvideSectionField } from "./types";

type AdvancingProvideSectionTemplateProps = { isLoading: true } | {
  isLoading?: false
  sections: Array<AdvancingFormSection<AdvancingProvideSectionField>>
  onValueChanged: (key: string, value: any) => void
  onEditStarted: (key: string) => void
}

export const AdvancingProvideSectionTemplate = (props: AdvancingProvideSectionTemplateProps) => {
  const validators = useValidators();

  // The explicit comparison narrows the props, strict null checks are off
  if (props.isLoading === true) return <SectionTemplateLoadingSkeleton rowCounts={[4, 3, 7, 5]} />;

  return <InPageEditingProvider
    enabled
    validate={validators.validateAll}
    onValueChanged={props.onValueChanged}
  >
    <ValidatorContext settings={validators.validatorSettings}>
      <SectionPanel.Section key="section">
        {props.sections.filter(section => !section.hidden).map(section =>
          <SectionPanel.Panel
            key={section.key}
            id={section.key}
            header={<SectionTemplateHeader>{section.title}</SectionTemplateHeader>}
          >
            <div className="advancing-provide-section-template-grid">
              {section.fields.filter(field => !field.hidden).map(field =>
                <AdvancingProvideFieldWithLabel key={field.key} field={field} onValueChanged={props.onValueChanged} onEditStarted={props.onEditStarted} validate={validators.validateAll} />
              )}
            </div>
          </SectionPanel.Panel>
        )}
      </SectionPanel.Section>
    </ValidatorContext>
  </InPageEditingProvider>
}
